import React, { useEffect, useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import TuneValueForm from './TuneValueForm'
import TuneValueComplete from './TuneValueComplete'
import {
  intializeState,
  runValuationComplete,
} from '../../../actions/valuation'
import {
  selectRequestedValuationSuccess,
  selectRequestedValuationFailure,
  selectRequestedValuationAmount,
  selectRequestedValuationUpdated,
  selectRequestedValuationError,
  selectHomeRefreshRequired,
  selectHomeFactsProgress,
} from '../../../store/selectors/valuation'
import { TuneNavigateBack } from '../../../constants/trackingEvents'
import HomeFacts from './HomeFacts/HomeFacts'
import { If, Unless } from '../..'
import { Page } from '../../shared/Routing'
import { dispatchEvent } from '../../../helpers/tagManager'
import { ActiveOverlayContext } from '../../shared/Routing/OverlayContext'

const PanelManager = () => {
  const dispatch = useDispatch()

  const { doNavBack } = useContext(ActiveOverlayContext)

  const progress = useSelector(selectHomeFactsProgress)
  const amount = useSelector(selectRequestedValuationAmount)
  const updated = useSelector(selectRequestedValuationUpdated)
  const success = useSelector(selectRequestedValuationSuccess)
  const failure = useSelector(selectRequestedValuationFailure)
  const error = useSelector(selectRequestedValuationError)
  const busy = useSelector(selectHomeRefreshRequired)

  useEffect(() => {
    dispatch(intializeState())
    return () => {
      dispatch(runValuationComplete())
      dispatch(intializeState())
    }
  }, [dispatch])

  useEffect(() => {
    if (progress === 100) {
      dispatch(runValuationComplete())
    }
  }, [progress, dispatch])

  const handleClickBack = () => {
    dispatchEvent(TuneNavigateBack, {
      eventLabel: 'Last: Finished',
    })

    doNavBack(true)
  }

  return (
    <>
      <Unless condition={progress}>
        <TuneValueForm />
      </Unless>
      <If condition={progress}>
        <Unless condition={progress === 100}>
          <Page>
            <Page.Body>
              <HomeFacts />
            </Page.Body>
          </Page>
        </Unless>
        <If condition={progress === 100}>
          <TuneValueComplete
            amount={amount}
            updated={updated || busy}
            success={success}
            failure={failure}
            busy={busy}
            error={error}
            onClickBack={handleClickBack}
          />
        </If>
      </If>
    </>
  )
}

export default PanelManager
